export function assetUrl(path: string) {
    if (process.env.NODE_ENV !== 'production') {
        return path;
    }

    if (path.startsWith('/')) {
        path = path.slice(1);
    }

    return `/wp-content/themes/branston-2020/dist/${path}`;
}
